export default __webpack_public_path__ + "static/media/call.d0f25d0d.svg";